import React from 'react';
import { RolesAccessPaginatedTable } from '@institutions/components';
import { Card } from '@common/components';

type Props = {
  supplierId: string;
  selectedRoles: string[];
  onRoleChange: (value: string[]) => void;
};

export function SuppliersManagementRolesAccessSelectionStep({
  supplierId,
  selectedRoles,
  onRoleChange,
}: Props) {
  return (
    <div className="suppliers-management-jobs-roles-selection-step">
      <Card>
        <RolesAccessPaginatedTable
          rolesAccessEditionMode
          selectedRowKeys={selectedRoles}
          setSelectedRowKeys={onRoleChange}
          supplierId={supplierId}
          hideStatusColumn
        />
      </Card>
    </div>
  );
}
